import { z } from 'zod'
import typeguard from '../typeguard'


export const loginResponseSchema = z.union([
  z.object({
    token: z.string(),
    rights: z.array(z.string()),
  }),
  z.literal(false),
])

export type loginResponse = z.infer<typeof loginResponseSchema>
export const isLoginResponse = typeguard<loginResponse>(loginResponseSchema)